// DO NOT EDIT — generated by tools/generate-automation-workflow-types.mts
// Source: shipstation/SS.Common/Enumerations.cs
// Regenerate: yarn workspace tools generate-automation-workflow-types
export const BackendActionTypeIds = {
  AddImporterOfRecord: 55,
  AddServiceLevel: 56,
  AddShipmentItem: 54,
  AddTag: 1,
  AdjustWeight: 17,
  Alcohol: 34,
  Alert: 13,
  AssignToUser: 24,
  BillDutiesToSender: 25,
  BillTo3rdParty: 27,
  BillToOtherAccount: 43,
  BlockAmazonLogistics: 49,
  COD: 44,
  Confirmation: 5,
  CustomsContent: 8,
  DangerousGoods: 41,
  DeclarationStatement: 38,
  DelegateFulfillmentProviderService: 50,
  DeliverByDate: 52,
  DeliveryEmailTemplate: 40,
  Dimensions: 15,
  DoNotNotifyMarketplaceOfShipment: 29,
  DryIce: 35,
  DryIceWeight: 37,
  Email: 12,
  EmailTemplate: 21,
  FillService: 28,
  Hold: 7,
  HoldUntil: 18,
  Ignore: 16,
  IncludeReturnLabel: 39,
  Insure: 4,
  InternalNote: 6,
  NonDelivery: 9,
  NonMachinable: 19,
  NoPostage: 26,
  NoteToBuyer: 23,
  OrderContainsDangerousGoods: 53,
  PackageType: 3,
  PackingSlip: 22,
  PrepaidDuties: 47,
  SaturdayDelivery: 33,
  SendCarrierNotifications: 51,
  ServiceCollection: 46,
  SetCustomField1: 30,
  SetCustomField2: 31,
  SetCustomField3: 32,
  ShipByDate: 42,
  ShipDate: 57,
  ShipperRelease: 36,
  ShippingService: 2,
  ShowPostage: 20,
  Stop: 11,
  TaxIdentifiers: 45,
  UseBlankBox: 48,
  Warehouse: 10,
  Weight: 14,
} as const;

export type BackendActionTypeId = (typeof BackendActionTypeIds)[keyof typeof BackendActionTypeIds];
